import { render, staticRenderFns } from "./AddCareRecord.vue?vue&type=template&id=52090752&scoped=true"
import script from "./AddCareRecord.vue?vue&type=script&lang=js"
export * from "./AddCareRecord.vue?vue&type=script&lang=js"
import style0 from "./AddCareRecord.vue?vue&type=style&index=0&id=52090752&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52090752",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52090752')) {
      api.createRecord('52090752', component.options)
    } else {
      api.reload('52090752', component.options)
    }
    module.hot.accept("./AddCareRecord.vue?vue&type=template&id=52090752&scoped=true", function () {
      api.rerender('52090752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/classManage/ClassOverviewDetail/components/CareStudentRecord/components/AddCareRecord.vue"
export default component.exports